/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveGroupsRequest
 */
export interface RemoveGroupsRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof RemoveGroupsRequest
     */
    groupIds: Array<number>;
}

/**
 * Check if a given object implements the RemoveGroupsRequest interface.
 */
export function instanceOfRemoveGroupsRequest(value: object): value is RemoveGroupsRequest {
    if (!('groupIds' in value) || value['groupIds'] === undefined) return false;
    return true;
}

export function RemoveGroupsRequestFromJSON(json: any): RemoveGroupsRequest {
    return RemoveGroupsRequestFromJSONTyped(json, false);
}

export function RemoveGroupsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveGroupsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'groupIds': json['group_ids'],
    };
}

export function RemoveGroupsRequestToJSON(json: any): RemoveGroupsRequest {
    return RemoveGroupsRequestToJSONTyped(json, false);
}

export function RemoveGroupsRequestToJSONTyped(value?: RemoveGroupsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_ids': value['groupIds'],
    };
}

